import { createApp } from 'vue/dist/vue.esm-bundler'
import ElectricBillCalculator from '../components/ElectricBillCalculator.vue'

document.addEventListener('turbo:load', () => {
  renderVue('vue-electric-bill-calculator', ElectricBillCalculator)
})

function renderVue(selector, component) {
  const element = document.getElementById(selector)
  if (element) {
    const app = createApp(component)
    app.mount(element)
  }
}

import { application } from "../controllers/application"

import JsonViewerController from "../controllers/tools/json_viewer_controller"
application.register("json-viewer", JsonViewerController)

import ExtractImageUrlsController from "../controllers/tools/extract_image_urls"
application.register("extract-image-urls", ExtractImageUrlsController)

import GlitterTextController from "../controllers/tools/glitter_text_controller"
application.register("glitter-text", GlitterTextController)
